module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_10_D_3.f91936a7.mp3";